module.exports = __webpack_public_path__ + "static/media/social_linkedin.82d7d849.svg";